import { Drawer, Tabs, Input, Button } from 'ui';
import { useIntl } from 'react-intl';
import EnumSelect from 'admin/Selects/EnumSelect';
import useQueryApiClient from 'utils/useQueryApiClient';
import { useEffect } from 'react';
import { Form, message } from 'antd';

interface CreateFarmUserDrawerProps {
  userEditId: number | undefined;
  setUserEditId: React.Dispatch<React.SetStateAction<number | undefined>>;
  fullName: string | undefined;
  reload: number;
  setReload: React.Dispatch<React.SetStateAction<number>>;
}

const EditUserDrawer = ({
  userEditId,
  setUserEditId,
  fullName,
  reload,
  setReload,
}: CreateFarmUserDrawerProps) => {
  const intl = useIntl();

  const { data } = useQueryApiClient({
    request: {
      url: `api/v2/user/info/${userEditId}`,
    },
    enabled: !!userEditId,
  });

  const updateuser = async () => {
    try {
      const values = await form.validateFields();
      updateData(values);
    } catch (e) {}
  };

  const handleClose = () => {
    setUserEditId(undefined);
  };

  const { appendData: updateData } = useQueryApiClient({
    request: {
      url: `api/v2/user/info/${userEditId}`,
      method: 'POST',
    },
    onSuccess: () => {
      setReload(reload + 1);
      message.success(intl.formatMessage({ id: 'general.save_message' }));
      handleClose();
    },
    onError: () =>
      message.error(intl.formatMessage({ id: 'general.save_error_message' })),
  });

  const [form] = Form.useForm();

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        name: data?.name,
        email: data?.email,
        id: data?.id,
        phone: data?.phone,
        role: data?.role,
        surname: data?.surname,
      });
    }
  }, [data]);

  const items = [
    {
      key: 'user_info',
      label: intl.formatMessage({ id: 'admin.user_info' }),
      children: (
        <Form form={form} layout="vertical">
          <Input
            label={intl.formatMessage({ id: 'register.name' })}
            name={'name'}
            className={'label-fix'}
          />
          <Input
            label={intl.formatMessage({ id: 'register.surname' })}
            name={'surname'}
          />
          <EnumSelect
            label={intl.formatMessage({ id: 'general.role' })}
            name="role"
            code="UserRoles"
          />
        </Form>
      ),
    },
    {
      key: 'communication',
      label: intl.formatMessage({ id: 'admin.communication' }),
      children: (
        <Form form={form} layout="vertical">
          <Input
            label={intl.formatMessage({ id: 'register.e_mail' })}
            size={'large'}
            name={'email'}
            validations={['required', 'email']}
          />
          <Input
            label={intl.formatMessage({ id: 'general.phone_number' })}
            size={'large'}
            name={'phone'}
            validations={['required', 'phoneNumber']}
          />
        </Form>
      ),
    },
  ];

  return (
    <Drawer
      open={!!userEditId}
      onClose={handleClose}
      title={intl.formatMessage({ id: 'general.edit_user' }) + ': ' + fullName}
      footer={
        <div className={'footer'}>
          <Button
            label={intl.formatMessage({ id: 'general.cancel' })}
            onClick={handleClose}
          />
          <Button
            type="primary"
            label={intl.formatMessage({ id: 'general.save' })}
            onClick={updateuser}
          />
        </div>
      }
      width={800}
      destroyOnClose
      styled
    >
      <Tabs items={items} />
    </Drawer>
  );
};

export default EditUserDrawer;
